import { ConditionalLink } from "components/conditionalLink";
import { Button } from "components/DesignSystem/Button/Button";
import { FeatureDetails } from "components/FeatureDetails/FeatureDetails";
import { useConstructInternalLink } from "hooks/useConstructInternalLink";
import { LockDescription } from "pages/Books/RevenueMetrics/RevenueMetricsLocked";
import { useLocation } from "react-router-dom";
import ExpenseRecognition from "static/images/ExpenseRecognition.png";

export const ExpenseRecognitionLocked = () => {
  const { link } = useConstructInternalLink();
  const { pathname } = useLocation();

  const settingsLink = link("/books/books-settings", {
    moreQuery: {
      settings_back_to: link(pathname),
    },
    hash: "AUTOMATION",
  });

  return (
    <section className="t-flex t-justify-center t-items-center t-h-full t-w-full">
      <FeatureDetails
        banner={
          <img
            src={ExpenseRecognition}
            alt="Expense recognition"
            width="360px"
          />
        }
        description={
          <LockDescription
            descriptionText="Track and understand how and when your expenses are incurred over time, with clean monthly views and fully audit-ready support."
            title="Expense Recognition"
          />
        }
        feature={<></>}
        button={
          <ConditionalLink to={settingsLink}>
            <Button customType="primary" size="regular">
              Enable Expense Recognition
            </Button>
          </ConditionalLink>
        }
      />
    </section>
  );
};
